import {
  CLOSE_ADD_MODAL, CLOSE_DELETE_MODAL,
  CLOSE_EDIT_MODAL, SUBMIT_DELETE_ITEM, DELETE_ITEM,
  OPEN_ADD_MODAL, OPEN_DELETE_MODAL, OPEN_EDIT_MODAL,
  RESET_STATE, LOAD_MORE, SUBMIT_ADD_ITEM,
  STORE_ITEMS, SUBMIT_UPDATE_ITEM, UPDATE_ITEM,
} from './actionTypes';

class CommonActions {
  constructor(reducerName) {
    this.reducerName = reducerName;
  }

  storeItems(itemsName, data) {
    return {
      type: STORE_ITEMS,
      reducerName: this.reducerName,
      payload: {
        data,
        itemsName,
      },
    };
  }

  submitAddItem() {
    return {
      type: SUBMIT_ADD_ITEM,
      reducerName: this.reducerName,
    };
  }

  loadMoreItems() {
    return {
      type: LOAD_MORE,
      reducerName: this.reducerName,
    };
  }

  openAddModal() {
    return {
      type: OPEN_ADD_MODAL,
      reducerName: this.reducerName,
    };
  }

  closeNewModal() {
    return {
      type: CLOSE_ADD_MODAL,
      reducerName: this.reducerName,
    };
  }

  openEditModal(id) {
    return {
      type: OPEN_EDIT_MODAL,
      reducerName: this.reducerName,
      payload: {
        id,
      },
    };
  }

  closeEditModal(id) {
    return {
      type: CLOSE_EDIT_MODAL,
      reducerName: this.reducerName,
      payload: {
        id,
      },
    };
  }

  openDeleteModal(id) {
    return {
      type: OPEN_DELETE_MODAL,
      reducerName: this.reducerName,
      payload: {
        id,
      },
    };
  }

  closeDeleteModal(id) {
    return {
      type: CLOSE_DELETE_MODAL,
      reducerName: this.reducerName,
      payload: {
        id,
      },
    };
  }

  submitUpdateItem(id) {
    return {
      type: SUBMIT_UPDATE_ITEM,
      reducerName: this.reducerName,
      payload: {
        id,
      },
    };
  }

  updateItem(itemsName, data) {
    return {
      type: UPDATE_ITEM,
      reducerName: this.reducerName,
      payload: {
        itemsName,
        data,
      },
    };
  }

  submitDeleteItem(id) {
    return {
      type: SUBMIT_DELETE_ITEM,
      reducerName: this.reducerName,
      payload: {
        id,
      },
    };
  }

  deleteItem(id) {
    return {
      type: DELETE_ITEM,
      reducerName: this.reducerName,
      payload: {
        id,
      },
    };
  }

  resetState() {
    return {
      type: RESET_STATE,
      reducerName: this.reducerName,
    };
  }
}

const commonActionsInstance = reducerName => new CommonActions(reducerName);
export default commonActionsInstance;



// WEBPACK FOOTER //
// ./src/actions/common.js